import type { PropsWithChildren } from "react";

import { DonutChart } from "@similarweb/pro-logic-components";
import { Flex } from "@similarweb/ui-components/foundations";

import { graphConfig } from "./chartConfig";
import { useMetricWidgetContext } from "./MetricWidgetContext";

const EMPTY_CHART_DATA: Parameters<typeof DonutChart>[0]["data"] = [];

export const MetricWidgetChart = ({ children }: PropsWithChildren) => {
    const {
        state: { compactChartData, compactData },
    } = useMetricWidgetContext();

    return (
        <Flex
            gap="32px"
            alignItems="center"
            padding="24px"
        >
            <DonutChart
                innerSize="60%"
                config={graphConfig}
                data={compactChartData ?? EMPTY_CHART_DATA}
                shouldPresentLegend={false}
            />
            {compactData.length > 0 ? children : null}
        </Flex>
    );
};
